/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/compass-off': {
    width: 69,
    height: 69,
    viewBox: '0 0 69 69',
    data: '<circle pid="0" cx="35.739" cy="33.018" r="28.002" _fill="#fff"/><path pid="1" d="M34.127 0C15.31 0 0 15.31 0 34.128c0 18.818 15.31 34.127 34.127 34.127 18.819 0 34.128-15.31 34.128-34.127C68.255 15.31 52.945 0 34.127 0zm0 43.38L18.079 53.457l16.05-44.565 16.05 44.565-16.05-10.077z" _fill="#000"/>'
  }
})
